/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home__Hero__Title_Part_2Inputs */

const en_home__hero__title_part_2 = /** @type {(inputs: Home__Hero__Title_Part_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thrill of Winning`)
};

/**
* | output |
* | --- |
* | "Thrill of Winning" |
*
* @param {Home__Hero__Title_Part_2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home__hero__title_part_2 = /** @type {((inputs?: Home__Hero__Title_Part_2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home__Hero__Title_Part_2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home__hero__title_part_2(inputs)
});